import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { BarriersState } from './types';
import { StateStatus } from '../../enums/StateStatus';

export const defaultBarriersState: BarriersState = {
  barriers: [],
  status: StateStatus.Initial,
  error: null,
  barrier: null,
  barrierLogs: []
};

export default function reducer(state: BarriersState = defaultBarriersState, action: Actions): BarriersState {
  switch (action.type) {
    case ActionTypes.GET_BARRIERS:
    case ActionTypes.CREATE_NEW_BARRIER:
    case ActionTypes.EDIT_BARRIER_DEVICE:
    case ActionTypes.DELETE_BARRIER_DEVICE:
    case ActionTypes.GET_BARRIER:
      return { ...state, status: StateStatus.Busy, error: null };
    case ActionTypes.GET_BARRIERS_SUCCESS:
      return { ...state, barriers: action.payload, status: StateStatus.Loaded };
    case ActionTypes.CREATE_NEW_BARRIER_SUCCESS:
    case ActionTypes.EDIT_BARRIER_DEVICE_SUCCESS:
    case ActionTypes.DELETE_BARRIER_DEVICE_SUCCESS:
      return { ...state, status: StateStatus.Loaded };
    case ActionTypes.GET_BARRIER_SUCCESS:
      return { ...state, barrier: action.payload, status: StateStatus.Loaded };
    case ActionTypes.GET_BARRIER_LOGS_SUCCESS:
      return { ...state, barrierLogs: action.payload, status: StateStatus.Loaded };
    case ActionTypes.GET_BARRIERS_ERROR:
    case ActionTypes.CREATE_NEW_BARRIER_ERROR:
    case ActionTypes.EDIT_BARRIER_DEVICE_ERROR:
    case ActionTypes.DELETE_BARRIER_DEVICE_ERROR:
    case ActionTypes.GET_BARRIER_ERROR:
    case ActionTypes.GET_BARRIER_LOGS_ERROR:
      return { ...state, error: action.payload, status: StateStatus.Error };
    default:
      return state;
  }
}
